module.exports = __webpack_public_path__ + "media/img/pages/companies/valais4you-9f6dd0f3dd2b5363eef6025d880105ce.png";